import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { classNames, UitkContextWrapper } from 'uitk-react-utils';
import styles from './uitk-field.css';
import { UitkFieldLabel } from './uitk-field-label.esm.js';
import { UitkFieldMessage } from './uitk-field-message.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkField = /** @class */ (function (_super) {
    __extends(UitkField, _super);
    function UitkField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkField.prototype.render = function () {
        var _a = this.props, className = _a.className, labelClassName = _a.labelClassName, label = _a.label, instruction = _a.instruction, invalid = _a.invalid, hasFloatedLabel = _a.hasFloatedLabel, icon = _a.icon, hasAutofill = _a.hasAutofill, hasBorder = _a.hasBorder, hasVisibleLabel = _a.hasVisibleLabel, children = _a.children, required = _a.required;
        var _b = this.props, id = _b.id, disabled = _b.disabled, placeholder = _b.placeholder, readOnly = _b.readOnly;
        var cssClassNames = getClassNameList('uitk-field', className, {
            'has-autofill': hasAutofill,
            'has-floatedLabel-label': hasFloatedLabel,
            'has-icon': icon,
            'has-no-border': !hasBorder,
            'has-no-visible-label': !hasVisibleLabel,
            'has-placeholder': !!(placeholder === null || placeholder === void 0 ? void 0 : placeholder.trim()),
            'has-textarea': React.Children.toArray(children).some(function (child) { return !!((child === null || child === void 0 ? void 0 : child.type) === 'textarea'); }),
            'is-disabled': disabled,
            'is-invalid': invalid,
            'is-readonly': readOnly,
            'is-required': required
        });
        var labelClassNames = [];
        labelClassName && labelClassNames.push(labelClassName);
        if (!hasVisibleLabel || !placeholder) {
            labelClassNames.push('is-visually-hidden');
        }
        var labelAttrs = {
            className: labelClassNames.join(' '),
            id: id,
            label: label,
            placeholder: placeholder
        };
        var messageMarkup = function (message, type) {
            var output;
            var isString = function (val) { return typeof val === 'string'; };
            var isObject = function (val) { return typeof val === 'object'; };
            if (message) {
                if (isString(message)) {
                    output = React.createElement(UitkFieldMessage, { id: id, message: message, type: type });
                }
                if (isObject(message)) {
                    output = (React.createElement("div", { className: getClassNameList('uitk-field-messages') },
                        message.primary && (React.createElement(UitkFieldMessage, { className: getClassNameList('uitk-field-message-primary'), id: id, message: message.primary, type: type })),
                        message.secondary && (React.createElement(UitkFieldMessage, { className: getClassNameList('uitk-field-message-secondary'), id: id, message: message.secondary, type: type }))));
                }
            }
            return output;
        };
        return (React.createElement(UitkContextWrapper, null, function (context, data) { return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: cssClassNames },
                React.createElement(UitkFieldLabel, __assign({}, labelAttrs)),
                children,
                !placeholder && hasVisibleLabel && (React.createElement("div", { className: getClassNameList('uitk-field-label'), "aria-hidden": "true" },
                    label,
                    required && (data === null || data === void 0 ? void 0 : data.hasRequiredFieldIndicator) && (React.createElement("span", { className: "uitk-field-required-asterisk", "aria-hidden": "true" },
                        ' ',
                        "*")))),
                icon && React.createElement(UitkIcon, { className: getClassNameList('uitk-field-icon'), name: icon })),
            invalid && messageMarkup(invalid, 'error'),
            instruction && messageMarkup(instruction, 'instruction'))); }));
    };
    UitkField.displayName = 'UitkField';
    UitkField.defaultProps = {
        hasBorder: true,
        hasFloatedLabel: true,
        hasVisibleLabel: true
    };
    return UitkField;
}(React.Component));

export { UitkField };
